<div class="container-fluid">
  <div class="page-title">
    <ol class="breadcrumb justify-content-start">
      <li class="breadcrumb-item breadcrumb-icon" [ngClass]="{'d-none': hideIcon}">
        <a [routerLink]="'/dashboard/default'">
          <svg class="stroke-icon">
            <use href="assets/svg/icon-sprite.svg#stroke-home"></use>
          </svg>
        </a>
      </li>
      <li class="breadcrumb-item breadcrumb-items" *ngFor="let item of items">{{ item | translate }}</li>
      <li class="breadcrumb-item active">{{ active_item | translate }}</li>
    </ol>
  </div>
</div>
